import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdatestoreMainFieldsData,
	billerDetailsTableColumns,
	getColDefaultValue,
	leaseDetails,
	storeBasicDetailsFields,
	storeCamTableColumns,
	storeMainFields,
	storeRentTableColumns,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { constraintsOptions } from "data/globalData";
import { inputTypes, statusOptions } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useState } from "react";

const AddOrEditModal = ({
	modal,
	setModal,
	type,
	selectedObj,
	createDetailsApi,
	selectedStore,
	setSelectedStore,
	handleUpdateDetails,
}) => {
	const defFields = (() => {
		let obj = {};
		storeRentTableColumns?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [rentDetails, setRentDetails] = useState(type === addOrEditModelAction.UPDATE ? selectedObj : defFields);

	const handleModalclose = () => {
		setModal(false);
	};
	const handleRentRevenueCallbackFun = (data) => {
		if (type === addOrEditModelAction.UPDATE) {
			let filtredData = selectedStore?.eboStoreRentAndRevenueShareDetails.filter((data) => data.id !== rentDetails.id);
			let depositDetail = [...filtredData, rentDetails];
			setSelectedStore({ ...selectedStore, eboStoreRentAndRevenueShareDetails: depositDetail });
		} else {
			let rentDetails = [...selectedStore?.eboStoreRentAndRevenueShareDetails, data];
			setSelectedStore({ ...selectedStore, eboStoreRentAndRevenueShareDetails: rentDetails });
		}
		setRentDetails(defFields);
		setModal(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		let updatedDeposit = { ...rentDetails, ebo_store_v4_id: selectedStore.store_code };
		if (type === addOrEditModelAction.UPDATE) {
			handleUpdateDetails(
				storesLinkedTables.store_rent_and_revenue_share_details.seqMethod,
				updatedDeposit,
				handleRentRevenueCallbackFun
			);
		} else {
			createDetailsApi(
				storesLinkedTables.store_rent_and_revenue_share_details.seqMethod,
				updatedDeposit,
				handleRentRevenueCallbackFun
			);
		}
	};
	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">
						{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Rent And Revenue Details
					</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{storeRentTableColumns?.map((row) => {
							return (
								<RenderInputField
									column={row}
									data={rentDetails}
									setData={setRentDetails}
									width="24%"
									selectOptObjName={"option_data"}
									dependencyColData={autoUpdatestoreMainFieldsData}
								/>
							);
						})}
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button
						variant="contained"
						disabled={selectedStore.status === statusOptions.PUBLISHED.key}
						sx={{ justifySelf: "center" }}
						type="submit">
						{type === addOrEditModelAction.UPDATE ? "UPDATE" : "CREATE"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
